(() => {
  const initializeInstructionPages = (scope = document) => {
    scope.querySelectorAll('[data-instructions-page]').forEach((page) => {
      if (page.dataset.instructionsInteractive === 'true') return;
      page.dataset.instructionsInteractive = 'true';

      const devices = page.querySelector('[data-instructions-devices]');
      const results = page.querySelector('[data-instructions-results]');
      const resultsHeading = page.querySelector('[data-instructions-results-heading]');
      const backButton = page.querySelector('[data-instructions-back]');
      const guideButtons = [...page.querySelectorAll('[data-instructions-guide]')];
      const dialog = page.querySelector('[data-instructions-video]');
      const dialogTitle = page.querySelector('[data-instructions-video-title]');
      const dialogMount = page.querySelector('[data-instructions-video-mount]');
      const dialogClose = page.querySelector('[data-instructions-video-close]');
      let videoTrigger;
      let restoreVideoFocus = false;

      const showDevices = (event) => {
        results.hidden = true;
        devices.hidden = false;
        devices.getAnimations().forEach((animation) => animation.cancel());
        devices.style.animation = 'none';
        window.requestAnimationFrame(() => {
          devices.style.animation = '';
          if (event?.detail === 0) devices.querySelector('button')?.focus();
        });
      };

      page.querySelectorAll('[data-instructions-device]').forEach((button) => {
        button.addEventListener('click', (event) => {
          const device = button.dataset.instructionsDevice;
          guideButtons.forEach((guide) => { guide.hidden = guide.dataset.instructionsGuide !== device; });
          resultsHeading.textContent = button.dataset.resultsHeading;
          devices.hidden = true;
          results.hidden = false;
          results.getAnimations().forEach((animation) => animation.cancel());
          results.style.animation = 'none';
          window.requestAnimationFrame(() => {
            results.style.animation = '';
            if (event.detail === 0) backButton.focus();
          });
        });
      });

      const closeVideo = () => {
        if (dialog.open) dialog.close();
      };

      backButton?.addEventListener('click', showDevices);
      guideButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          const videoId = button.dataset.videoId;
          if ((!videoId && button.dataset.guideHasContent !== 'true') || !dialog || !dialogMount) return;
          videoTrigger = button;
          restoreVideoFocus = event.detail === 0;
          dialogTitle.textContent = button.dataset.videoTitle;
          let player;
          if (videoId) {
            player = document.createElement('lite-youtube');
            player.setAttribute('videoid', videoId);
            player.setAttribute('title', button.dataset.videoTitle);
            player.setAttribute('playlabel', button.getAttribute('aria-label'));
            dialogMount.replaceChildren(player);
          } else {
            const template = button.nextElementSibling;
            dialogMount.replaceChildren(template?.content?.cloneNode(true) || document.createTextNode(''));
          }
          dialog.showModal();
          document.body.classList.add('instructions-video-is-open');
          player?.activate();
        });
      });

      dialogClose?.addEventListener('click', closeVideo);
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) closeVideo();
      });
      dialog?.addEventListener('close', () => {
        dialogMount.replaceChildren();
        document.body.classList.remove('instructions-video-is-open');
        if (!restoreVideoFocus) videoTrigger?.blur();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeInstructionPages(), { once: true });
  } else {
    initializeInstructionPages();
  }

  document.addEventListener('shopify:section:load', (event) => initializeInstructionPages(event.target));
})();
